import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
declare var $: any; // Declarar jQuery para TypeScript

@Component({
  selector: 'app-proyectos-d',
  templateUrl: './proyectos-d.component.html',
  styleUrls: ['./proyectos-d.component.css']
})
export class ProyectosDComponent implements OnInit {

  proyecto = {
    clave: '',
    nombre: '',
    id_cliente: 0,
    // nombre_cliente: '',
    id_dirfact: 0,
    clave_dirfact: '',
    id_administrador: 0,
    nombre_administrador: '',
    id_supervisor: 0,
    nombre_supervisor: '',
    id_responsable: 0,
    nombre_responsable: '',
    fecha_inicio: '',
    fecha_fin: '',
    estatus: '',
    id_administradores: '',
    nombre_administradores: ''
  }

  opE: any;
  token: any;
  retrievedProjet: any;
  usuarios: any[] = [];
  areas: any[] = [];
  clientes: any[] = [];
  rol: any;

  usuariosAP: any;
  usuariosS: any;
  usuariosD: any;

  // declaración de los mensajes de validación 
  showErrorMessageNombre: boolean = false;
  showErrorMessageClave: boolean = false;
  showErrorMessageFact: boolean = false;
  showErrorMessageAdm: boolean = false;
  showErrorMessageSup: boolean = false;
  showErrorMessageResp: boolean = false;
  showErrorMessageIni: boolean = false;
  showErrorMessageFin: boolean = false;
  showErrorMessageEst: boolean = false;

  mensajeValidacionNombre: string = '';
  mensajeValidacionClave: string = '';
  mensajeValidacionFact: string = '';
  mensajeValidacionAdm: string = '';
  mensajeValidacionSup: string = '';
  mensajeValidacionResp: string = '';
  mensajeValidacionIni: string = '';
  mensajeValidacionFin: string = '';
  mensajeValidacionEst: string = '';

  mensaje: string = 'Campo requerido.';

  iconoMostrar: string = '';
  nameBoton: string = '';
  

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private messagesService: MessagesService,
    private navigationService: NavigationService,
    private filtrarProyectosService: FiltrarProyectosService
  ) { }

  ngOnInit() {
    this.obtenerDatos();
    this.obtenerUsuario();
    this.obtnerIcono();
  }

  obtnerIcono(){
    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton = this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  ngAfterViewInit() {
    this.seleccionVariosAdministradores();
  }

  seleccionVariosAdministradores() {
    $('#id_administrador').select2({
      placeholder: 'Seleccionar administrador...',
      multiple: true
    }).on('change', (e: any) => {
      let selectedValues = $(e.target).val();
      // Procesa los valores para extraer solo la parte después del `:`
      this.proyecto.id_administrador = selectedValues ? selectedValues.map((val: any) => {
        const parts = val.split(':');
        return parts.length > 1 ? Number(parts[1].trim()) : Number(val);
      }) : [];
    }).on('select2:close', (e: any) => {
      // Llamar a mostrarMensaje solo si el campo está sucio o tocado
      this.mostrarMensaje(this.proyecto.id_administrador, 'adm');
    });
  }

  setSelectedRoles() {
    // Si user.rol es un número, conviértelo en array
    if (typeof this.proyecto.id_administrador === 'number') {
      $('#id_administrador').val([this.proyecto.id_administrador]).trigger('change');
    } else if (Array.isArray(this.proyecto.id_administrador)) {
      $('#id_administrador').val(this.proyecto.id_administrador).trigger('change');
    } else {
      console.error('Tipo inesperado para this.proyecto.id_administrador:', this.proyecto.id_administrador);
    }
  }

  obtenerDatos() {
    const { rol, token } = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.rol = rol;

    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');

    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedProjet = this.sharedService.getDataArray();
      this.cargarProjet(this.retrievedProjet);
    }

  }

  obtenerUsuario() {
    this.requestsService.getAllUser(this.token).subscribe(
      (data: any) => {
        this.usuarios = data.map((usuario: any) => {
          return {
            ...usuario,
            Id_Usuario: Number(usuario.Id_Usuario) // Asegúrate de que Id_Usuario sea un número
          };
        });

        // Inicializamos los arrays para almacenar usuarios según sus roles
        this.usuariosAP = [];
        this.usuariosS = [];
        this.usuariosD = [];

        // Recorrer todos los usuarios y clasificar según el rol o roles_nombres
        this.usuarios.forEach((usuario: any) => {
          if (usuario.Usr_Activo) {
            // Si el usuario tiene un solo rol
            if (usuario.rol_nombre) {
              if (usuario.rol_nombre === 'Administrador del proyecto') {
                this.usuariosAP.push(usuario);
              } else if (usuario.rol_nombre === 'Supervisor del proyecto') {
                this.usuariosS.push(usuario);
              } else if (
                usuario.rol_nombre === 'Director general' ||
                usuario.rol_nombre === 'Director general adjunto' ||
                usuario.rol_nombre === 'Director de estrategia de proyectos'
              ) {
                this.usuariosD.push(usuario);
              }
            } else if (usuario.roles_nombres) {
              // Si el usuario tiene múltiples roles en roles_nombres
              const roles = usuario.roles_nombres.split(',').map((role: string) => role.trim());

              if (roles.includes('Administrador del proyecto')) {
                this.usuariosAP.push(usuario);
              }
              if (roles.includes('Supervisor del proyecto')) {
                this.usuariosS.push(usuario);
              }
              if (
                roles.includes('Director general') ||
                roles.includes('Director general adjunto') ||
                roles.includes('Director de estrategia de proyectos')
              ) {
                this.usuariosD.push(usuario);
              }
            }
          }
        });


        // Si no se encontraron roles, imprime el mensaje
        if (!this.usuariosAP.length && !this.usuariosS.length && !this.usuariosD.length) {
          console.log('sin roles');
        }
      }, (error) => {
        this.mostrarError(error.message);
      });

    this.obtenerArea();
    this.obtenerClientes();
  }

  obtenerArea() {
    this.requestsService.getAllArea(this.token).subscribe(
      (data: any) => {
        this.areas = Object.values(data);
      });
  }

  obtenerClientes() {
    this.requestsService.getAllClient(this.token).subscribe(
      (data: any) => {
        this.clientes = Object.values(data);
      });
  }

  async cargarProjet(getprojet: any) {
    this.proyecto.clave = getprojet.Pry_Clave;
    this.proyecto.nombre = getprojet.Pry_Nombre;
    this.proyecto.id_cliente = Number(getprojet.FKId_Cliente);
    // this.proyecto.nombre_cliente = getprojet.Pry_CliNombre;
    this.proyecto.id_dirfact = Number(getprojet.FKId_Direccion);
    this.proyecto.clave_dirfact = getprojet.Pry_DirClave;
    this.proyecto.id_supervisor = Number(getprojet.FKId_Supervisor);
    this.proyecto.nombre_supervisor = getprojet.Pry_Supervisor;
    this.proyecto.id_responsable = Number(getprojet.FKId_Responsable);
    this.proyecto.nombre_responsable = getprojet.Pry_Responsable;
    this.proyecto.fecha_inicio = this.obtenerFormatoFecha(getprojet.Pry_FechaInicio);
    this.proyecto.fecha_fin = this.obtenerFormatoFecha(getprojet.Pry_FechaFin);
    this.proyecto.estatus = getprojet.Pry_Estatus;
    this.proyecto.nombre_administrador = getprojet.Pry_Administrador;
    this.activarAdmistradores(getprojet);
    // Llama a setSelectedRoles después de establecer los datos
    this.setSelectedRoles();
  }

  activarAdmistradores(getprojet: any) {
    // Asegúrate de que id_administrador sea un array de números
    if (getprojet.FKId_Administrador !== 74) {
      this.proyecto.id_administrador = getprojet.FKId_Administrador;
      this.proyecto.id_administrador = Array.isArray(getprojet.FKId_Administrador) ? getprojet.FKId_Administrador : [getprojet.FKId_Administrador];
    } else {
      let cadena = getprojet.FKId_Administradores;
      let resultado = cadena.split(', ').map(Number);
      this.proyecto.id_administrador = resultado;
    }
  }

  obtenerFormatoFecha(fecha: string): string {
    const fechaObj = new Date(fecha);
    const formatoFecha = fechaObj.toISOString().split('T')[0];
    return formatoFecha;
  }

  guardarAdministradores(seleccion: any) {
    // Convierte los elementos del array a enteros
    const ids = seleccion.map((id: any) => parseInt(id, 10)); // Asegura la conversión a enteros
    // guardamos los los id´s de los administradores seleccionados 
    this.proyecto.id_administradores = ids.join(', ');
    // Filtra los administradores usando los IDs
    const admins = this.usuariosAP.filter((usuario: any) => ids.includes(usuario.Id_Usuario));
    // Mapea los nombres de los administradores y los concatena en un string
    this.proyecto.nombre_administradores = admins.length > 0 ? admins.map((admin: any) => admin.Usr_Nombre).join(', ') : '';

    // guardamos los datos en duro para saber que seleccionaron varios
    this.proyecto.id_administrador = 74;
    this.proyecto.nombre_administrador = 'sin nombre';
  }

  obtenerSeleccion() {
    let llegada: any = this.proyecto.id_administrador;
    if (llegada.length === 1) {
      //solo se asignara un administrador
      // se guarda el id
      this.proyecto.id_administrador = llegada[0];
      // se busca el nombre del administrador
      const administrador = this.usuariosAP.find((admin: any) => admin.Id_Usuario === llegada[0]);
      // se asigna el nombre del administrador
      this.proyecto.nombre_administrador = administrador.Usr_Nombre;

      // guardamos los datos en duro para saber que selecciono solo uno
      this.proyecto.id_administradores = '74';
      this.proyecto.nombre_administradores = 'sin nombre';
    } else {
      // se asignaran varios administradores
      this.guardarAdministradores(llegada);
    }

    // obtener nombre del supervisor
    const supervisor = this.usuariosS.find((usuario: any) => Number(usuario.Id_Usuario) === Number(this.proyecto.id_supervisor));
    this.proyecto.nombre_supervisor = supervisor.Usr_Nombre;

    // obtener nombre del responsable
    const responsable = this.usuariosD.find((usuario: any) => Number(usuario.Id_Usuario) === Number(this.proyecto.id_responsable));
    this.proyecto.nombre_responsable = responsable.Usr_Nombre;

    // obtener nombre del area
    const area = this.areas.find(area => area.Id_Direccion === String(this.proyecto.id_dirfact));
    this.proyecto.clave_dirfact = area.Dir_Clave;
  }


  async validaFormulario(guardar: any, editar: any) {
    if (this.proyecto.nombre === '' || this.proyecto.id_administrador === undefined || this.proyecto.id_supervisor === undefined || this.proyecto.id_responsable === undefined || this.proyecto.fecha_inicio === '' || this.proyecto.fecha_fin === '' || this.proyecto.estatus === '') {
      this.messagesService.showError('Todos los campos son obligatorios');
      return;
    } else {
      this.obtenerSeleccion();
    }

    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar()
    }
  }

  asignarDatos() {
    this.proyecto.id_dirfact = Number(this.proyecto.id_dirfact);
    this.proyecto.id_supervisor = Number(this.proyecto.id_supervisor);
    this.proyecto.id_responsable = Number(this.proyecto.id_responsable);
    this.proyecto.id_administrador = this.proyecto.id_administrador;
  }
  
  editar() {
    this.asignarDatos();
    this.requestsService.editProjet(this.proyecto, this.retrievedProjet.Id_Proyecto, this.token).subscribe(
      (res) => {
        this.confirmacion(res.message);
      }, (err) => {
        this.mostrarError(err.message);
      }
    )
  }

  guardar() {
    this.asignarDatos();
    this.requestsService.createProjet(this.proyecto, this.token).subscribe(
      (res) => {
        this.confirmacion(res.message);
      }, (err) => {
        this.mostrarError(err.message);
      }
    )
  }

  eliminar() {
    this.requestsService.deleteProjet(this.retrievedProjet.Id_Proyecto, this.token).subscribe(
      (res) => {
        this.confirmacion(res.message);
      }, (err) => {
        this.mostrarError(err.error.error[0].message);
      }
    )
  }

  confirmacion(mensajeConfirmacion: string) {
    this.messagesService.showMessage(mensajeConfirmacion);
    this.cancelar();
  }

  mostrarError(mensajeError: string) {
    this.messagesService.showError(mensajeError);
  }

  cancelar() {
    this.router.navigate(['/proyectos']);
  }

  private isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  private isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  // mensajes de validación 
  mostrarMensaje(campo: any, tipo: string) {
    switch (tipo) {
      case 'nombre':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageNombre = true;
          this.mensajeValidacionNombre = this.mensaje;
        } else {
          this.showErrorMessageNombre = false;
        }
        break;
      case 'clave':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageClave = true;
          this.mensajeValidacionClave = this.mensaje;
        } else {
          this.showErrorMessageClave = false;
        }
        break;
      case 'fact':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageFact = true;
          this.mensajeValidacionFact = this.mensaje;
        } else {
          this.showErrorMessageFact = false;
        }
        break;
      case 'adm':
        if (campo.length === 0) {
          this.showErrorMessageAdm = true;
          this.mensajeValidacionAdm = this.mensaje;
        } else {
          this.showErrorMessageAdm = false;
        }
        break;
      case 'sup':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageSup = true;
          this.mensajeValidacionSup = this.mensaje;
        } else {
          this.showErrorMessageSup = false;
        }
        break;
      case 'resp':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageResp = true;
          this.mensajeValidacionResp = this.mensaje;
        } else {
          this.showErrorMessageResp = false;
        }
        break;
      case 'ini':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageIni = true;
          this.mensajeValidacionIni = this.mensaje;
        } else {
          this.showErrorMessageIni = false;
        }
        break;
      case 'fin':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageFin = true;
          this.mensajeValidacionFin = this.mensaje;
        } else {
          this.showErrorMessageFin = false;
        }
        break;
      case 'est':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageEst = true;
          this.mensajeValidacionEst = this.mensaje;
        } else {
          this.showErrorMessageEst = false;
        }
        break;
    }
  }

}
